module.exports = __webpack_public_path__ + "static/media/howitwork2.517d0fc9.jpg";